"use client";

import { useEffect, useState } from "react";
import { Category as ICategory } from "../types";
import Link from "next/link";
import Category from "../components/category";
import { Container } from "../components/container";
import { getCategories } from "./getCategories";
import { LoadMore } from "../components/load-more";

type Props = {
  initialCategories: ICategory[];
  initialPage: number;
  pageCount: number;
};

export const CategoryList = ({
  initialCategories,
  initialPage,
  pageCount,
}: Props) => {
  const [categories, setCategories] = useState<ICategory[]>(initialCategories);
  const [page, setPage] = useState(initialPage);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (page === initialPage) return;

    setIsLoading(true);

    getCategories(page)
      .then((response) => {
        setCategories((prev) => [...prev, ...(response?.data ?? [])]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [page, initialPage]);

  return (
    <Container className="flex flex-col items-center max-w-[1232px] mx-auto">
      <div className="grid grid-cols-1 mx-auto text-center md:grid-cols-2 lg:grid-cols-4 gap-4 max-w-[215px] md:max-w-none pb-10">
        {categories.map((category: ICategory) => (
          <Link
            key={category.id}
            href={`/categories/${category.slug}`}
            className=""
          >
            <Category key={category.id} category={category} />
          </Link>
        ))}
      </div>

      {pageCount > 1 && <LoadMore disabled={isLoading || page >= pageCount} isLoading={isLoading} onClick={() => setPage((p) => p + 1)} />}

    </Container>
  );
};
